import React, { useEffect, useState, useCallback } from 'react';
import styles from './unsubscribe.module.scss';
import { useParams } from 'react-router-dom';
import Spinner from 'src/components/spinner/Spinner';
import { useUnsubscribeMutation } from 'src/api/graphql-codegen';

type Params = { id: string };

function Unsubscribe() {
  const { id } = useParams<Params>();
  const [unsubscribe, { loading: unsubscribePending }] = useUnsubscribeMutation();
  const [isUnsubscribed, setUnsubscribeState] = useState(false);

  const onUnsubscribe = useCallback(async () => {
    const result = await unsubscribe({ variables: { input: { id } } });
    if (!!result?.data?.unsubscribe) {
      setUnsubscribeState(true);
    }
  }, [id, unsubscribe]);

  useEffect(() => {
    if (id && !unsubscribePending) {
      onUnsubscribe();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.container}>
      {unsubscribePending ? <div className={styles.spinner}><Spinner/></div> : (
        isUnsubscribed ? (
          <div className={styles.headerWrapper}>
            <div className={styles.title}>Successfully unsubscribed!</div>
          </div>
        ) : (
          <div className={styles.headerWrapper}>
            <div className={styles.title}>Unsubscribe failed, please try again!</div>
          </div>
        )
      )

      }
    </div>
  );
}

export default Unsubscribe;
